import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
import {
  Grid,
  Drawer,
  TextField,
  InputAdornment,
  Typography,
  ClickAwayListener,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import AppsIcon from "@mui/icons-material/Apps";
// import { Link } from "react-router-dom";
// import { styled } from "@mui/material/styles";
import MenuList from "@mui/material/MenuList";
import ListItemText from "@mui/material/ListItemText";
import ListItemIcon from "@mui/material/ListItemIcon";
import { ListItemButton } from "@mui/material";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { styled } from "@mui/material/styles";
import {
  MainMenu,
  SwiftMenu,
  SwiftRoutes,
  AlertsMenu,
  AlertsRoutes,
  MatchingMenu,
  MatchingRoutes,
  AdminToolMenu,
  AdminToolRoutes,
  UserManagementMenu,
  UserManagementRoutes,
} from "../../data";

const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: "top",
      horizontal: "left",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "right",
    }}
    {...props}
    sx={{ marginLeft: "230px" }}
  />
))(({ theme }) => ({
  "& .MuiPaper-root": {
    borderRadius: 6,
    minWidth: 210,
    color: "#050D2E",
    boxShadow:
      "rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
    "& .MuiMenu-list": {
      padding: "4px 0",
    },
    "& .MuiMenuItem-root": {
      color: "#050D2E",
      "&:active": {
        backgroundColor: "#D4EDF3",
      },
      "&:hover": {
        backgroundColor: "#D4EDF3",
      },
    },
  },
}));

const SideMenu = () => {
  const { pathname } = useLocation();
  const [anchorEl, setAnchorEl] = useState(null);
  const [nestedMenu, setNestedMenu] = useState([]);
  const [settingsDrawerOpen, setSettingsDrawerOpen] = useState(false);

  const open = Boolean(anchorEl);
  const handleAdminToolClick = (event) => {
    setAnchorEl(event.currentTarget);
    setNestedMenu(AdminToolMenu);
  };
  const handleUserManagementClick = (event) => {
    setAnchorEl(event.currentTarget);
    setNestedMenu(UserManagementMenu);
  };
  const handleCloseNestedMenu = () => {
    setAnchorEl(null);
  };

  const toggleSettingsDrawer = () => {
    setSettingsDrawerOpen(!settingsDrawerOpen);
  };

  return (
    <Drawer
      variant="permanent"
      sx={{
        display: { xs: "none", sm: "block" },
        "& .MuiDrawer-paper": {
          boxSizing: "border-box",
          width: "240px",
          marginTop: "48px",
          padding: "8px",
          background: "#FFFFFF",
          height: `${window.innerHeight - 48}px`,
        },
      }}
      open
    >
      <Grid container justifyContent="space-between" alignItems="center">
        <Grid item sx={{ padding: "8px" }}>
          <TextField
            sx={{ width: "172px", height: "32px", padding: "0px" }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end" sx={{ paddingRight: "5px" }}>
                  <SearchIcon />
                </InputAdornment>
              ),
              placeholder: "Quick Access",
              sx: { width: "172px", height: "32px", padding: "0px" },
            }}
            variant="outlined"
          />
        </Grid>
        <Grid item>
          <AppsIcon sx={{ width: "32px", height: "28px" }} />
        </Grid>
      </Grid>

      {SwiftRoutes.includes(pathname) ? (
        <>
          <Grid container sx={{ padding: "16px" }}>
            <Grid item>
              <Link to="/" style={{ textDecoration: "none" }}>
                <KeyboardArrowLeftIcon fontSize="medium" />
              </Link>
            </Grid>
            <Grid item>
              <Typography sx={{ color: "#050D2E", fontWeight: "600" }}>
                SWIFT
              </Typography>
            </Grid>
          </Grid>
          <MenuList sx={{ width: "200px", padding: "8px" }}>
            {SwiftMenu.map((item) => {
              return (
                <Link
                  key={item.id}
                  to={item.path}
                  style={{ textDecoration: "none" }}
                >
                  <ListItemButton
                    sx={{
                      padding: "8px",
                      maxHeight: "32px",
                      height: "32px",
                      width: "216px",
                      "&:hover": { backgroundColor: "#D4EDF3" },
                      backgroundColor:
                        pathname === item.path ? "#D4EDF3" : "#fffff",
                    }}
                  >
                    <ListItemText
                      sx={{
                        color: pathname === item.path ? "#1492AF" : "#050D2E",
                        "& .MuiTypography-root": {
                          fontWeight: pathname === item.path ? "550" : "400",
                        },
                      }}
                    >
                      {item.name}
                    </ListItemText>
                  </ListItemButton>
                </Link>
              );
            })}
          </MenuList>
        </>
      ) : AlertsRoutes.includes(pathname) ? (
        <>
          <Grid container sx={{ padding: "16px" }}>
            <Grid item>
              <Link to="/" style={{ textDecoration: "none" }}>
                <KeyboardArrowLeftIcon fontSize="medium" />
              </Link>
            </Grid>
            <Grid item>
              <Typography sx={{ color: "#050D2E", fontWeight: "600" }}>
                Alerts&Notifications
              </Typography>
            </Grid>
          </Grid>
          <MenuList sx={{ width: "200px", padding: "8px" }}>
            {AlertsMenu.map((item) => {
              return (
                <Link
                  key={item.id}
                  to={item.path}
                  style={{ textDecoration: "none" }}
                >
                  <ListItemButton
                    sx={{
                      padding: "8px",
                      maxHeight: "32px",
                      height: "32px",
                      width: "216px",
                      "&:hover": { backgroundColor: "#D4EDF3" },
                      backgroundColor:
                        pathname === item.path ? "#D4EDF3" : "#fffff",
                    }}
                  >
                    <ListItemText
                      sx={{
                        color: pathname === item.path ? "#1492AF" : "#050D2E",
                        "& .MuiTypography-root": {
                          fontWeight: pathname === item.path ? "550" : "400",
                          fontSize: "14px",
                        },
                      }}
                    >
                      {item.name}
                    </ListItemText>
                  </ListItemButton>
                </Link>
              );
            })}
          </MenuList>
        </>
      ) : MatchingRoutes.includes(pathname) ? (
        <>
          <Grid container sx={{ padding: "16px" }}>
            <Grid item>
              <Link to="/" style={{ textDecoration: "none" }}>
                <KeyboardArrowLeftIcon fontSize="medium" />
              </Link>
            </Grid>
            <Grid item>
              <Typography sx={{ color: "#050D2E", fontWeight: "600" }}>
                Matching
              </Typography>
            </Grid>
          </Grid>
          <MenuList sx={{ width: "200px", padding: "8px" }}>
            {MatchingMenu.map((item) => {
              return (
                <Link
                  key={item.id}
                  to={item.path}
                  style={{ textDecoration: "none" }}
                >
                  <ListItemButton
                    sx={{
                      padding: "8px",
                      maxHeight: "32px",
                      height: "32px",
                      width: "216px",
                      "&:hover": { backgroundColor: "#D4EDF3" },
                      backgroundColor:
                        pathname === item.path ? "#D4EDF3" : "#fffff",
                    }}
                  >
                    <ListItemText
                      sx={{
                        color: pathname === item.path ? "#1492AF" : "#050D2E",
                        "& .MuiTypography-root": {
                          fontWeight: pathname === item.path ? "550" : "400",
                        },
                      }}
                    >
                      {item.name}
                    </ListItemText>
                  </ListItemButton>
                </Link>
              );
            })}
          </MenuList>
        </>
      ) : AdminToolRoutes.includes(pathname) ? (
        <>
          <Grid container sx={{ padding: "16px" }}>
            <Grid item>
              <Link to="/" style={{ textDecoration: "none" }}>
                <KeyboardArrowLeftIcon fontSize="medium" />
              </Link>
            </Grid>
            <Grid item>
              <Typography sx={{ color: "#050D2E", fontWeight: "600" }}>
                Admin Tool
              </Typography>
            </Grid>
          </Grid>
          <MenuList sx={{ width: "200px", padding: "8px" }}>
            {AdminToolMenu.map((item) => {
              return (
                <Link
                  key={item.id}
                  to={item.path}
                  style={{ textDecoration: "none" }}
                >
                  <ListItemButton
                    sx={{
                      padding: "8px",
                      maxHeight: "32px",
                      height: "32px",
                      width: "216px",
                      "&:hover": { backgroundColor: "#D4EDF3" },
                      backgroundColor:
                        pathname === item.path ? "#D4EDF3" : "#fffff",
                    }}
                  >
                    <ListItemText
                      sx={{
                        color: pathname === item.path ? "#1492AF" : "#050D2E",
                        "& .MuiTypography-root": {
                          fontWeight: pathname === item.path ? "550" : "400",
                        },
                      }}
                    >
                      {item.name}
                    </ListItemText>
                  </ListItemButton>
                </Link>
              );
            })}
          </MenuList>
        </>
      ) : UserManagementRoutes.includes(pathname) ? (
        <>
          <Grid container sx={{ padding: "16px" }}>
            <Grid item>
              <Link to="/" style={{ textDecoration: "none" }}>
                <KeyboardArrowLeftIcon fontSize="medium" />
              </Link>
            </Grid>
            <Grid item>
              <Typography sx={{ color: "#050D2E", fontWeight: "600" }}>
                User Management
              </Typography>
            </Grid>
          </Grid>
          <MenuList sx={{ width: "200px", padding: "8px" }}>
            {UserManagementMenu.map((item) => {
              return (
                <Link
                  key={item.id}
                  to={item.path}
                  style={{ textDecoration: "none" }}
                >
                  <ListItemButton
                    sx={{
                      padding: "8px",
                      maxHeight: "32px",
                      height: "32px",
                      width: "216px",
                      "&:hover": { backgroundColor: "#D4EDF3" },
                      backgroundColor:
                        pathname === item.path ? "#D4EDF3" : "#fffff",
                    }}
                  >
                    <ListItemText
                      sx={{
                        color: pathname === item.path ? "#1492AF" : "#050D2E",
                        "& .MuiTypography-root": {
                          fontWeight: pathname === item.path ? "550" : "400",
                        },
                      }}
                    >
                      {item.name}
                    </ListItemText>
                  </ListItemButton>
                </Link>
              );
            })}
          </MenuList>
        </>
      ) : (
        <>
          <Grid container direction="column" sx={{ padding: "8px" }}>
            <Typography
              sx={{ fontSize: "12px", lineHeight: "14px", color: "#8792AB" }}
            >
              MODULES
            </Typography>
            <MenuList sx={{ width: "216px" }}>
              {MainMenu.modules.map((item) => {
                return (
                  <Link
                    key={item.id}
                    to={item.path}
                    style={{ textDecoration: "none" }}
                  >
                    <ListItemButton
                      sx={{
                        padding: "8px",
                        maxHeight: "32px",
                        height: "32px",
                        width: "216px",
                        "&:hover": { backgroundColor: "#D4EDF3" },
                        backgroundColor:
                          pathname === item.path ? "#D4EDF3" : "#fffff",
                      }}
                    >
                      <ListItemIcon
                        sx={{
                          width: "24px",
                          minWidth: "24px",
                          height: "24px",
                          paddingRight: "5px",
                          color: pathname === item.path ? "#1492AF" : "#50566E",
                        }}
                      >
                        {item.icon}
                      </ListItemIcon>
                      <ListItemText
                        sx={{
                          color: pathname === item.path ? "#1492AF" : "#050D2E",
                          "& .MuiTypography-root": {
                            fontWeight: pathname === item.path ? "550" : "400",
                          },
                        }}
                      >
                        {item.name}
                      </ListItemText>
                    </ListItemButton>
                  </Link>
                );
              })}
            </MenuList>
          </Grid>
          <Grid container direction="column" sx={{ padding: "8px" }}>
            <Typography
              sx={{ fontSize: "12px", lineHeight: "14px", color: "#8792AB" }}
            >
              SETTINGS
            </Typography>
            <MenuList sx={{ width: "216px" }}>
              {MainMenu.settings.map((item) => {
                return (
                  <div key={item.id}>
                    {item.path ? (
                      <Link to={item.path} style={{ textDecoration: "none" }}>
                        <ListItemButton
                          sx={{
                            padding: "8px",
                            maxHeight: "32px",
                            height: "32px",
                            width: "216px",
                            "&:hover": { backgroundColor: "#D4EDF3" },
                            backgroundColor:
                              pathname === item.path ? "#D4EDF3" : "#fffff",
                          }}
                        >
                          <ListItemIcon
                            sx={{
                              width: "24px",
                              minWidth: "24px",
                              height: "24px",
                              paddingRight: "5px",
                              color:
                                pathname === item.path ? "#1492AF" : "#50566E",
                            }}
                          >
                            {item.icon}
                          </ListItemIcon>
                          {item.path ? (
                            <ListItemText
                              sx={{
                                color:
                                  pathname === item.path
                                    ? "#1492AF"
                                    : "#050D2E",
                                "& .MuiTypography-root": {
                                  fontWeight:
                                    pathname === item.path ? "550" : "400",
                                },
                              }}
                            >
                              {item.name}
                            </ListItemText>
                          ) : (
                            <ListItemText sx={{ color: "#050D2E" }}>
                              {item.name}
                            </ListItemText>
                          )}
                        </ListItemButton>
                      </Link>
                    ) : (
                      <ListItemButton
                        sx={{
                          padding: "8px",
                          maxHeight: "32px",
                          height: "32px",
                          width: "216px",
                          "&:hover": { backgroundColor: "#D4EDF3" },
                          backgroundColor:
                            pathname === item.path ? "#D4EDF3" : "#fffff",
                        }}
                        onClick={
                          item.id === "Admin Tool"
                            ? handleAdminToolClick
                            : handleUserManagementClick
                        }
                      >
                        <ListItemIcon
                          sx={{
                            width: "24px",
                            minWidth: "24px",
                            height: "24px",
                            paddingRight: "5px",
                            color:
                              pathname === item.path ? "#1492AF" : "#50566E",
                          }}
                        >
                          {item.icon}
                        </ListItemIcon>

                        <ListItemText
                          sx={{ color: "#050D2E", fontSize: ".938rem" }}
                        >
                          {item.name}
                        </ListItemText>
                        <KeyboardArrowRightIcon />
                      </ListItemButton>
                    )}
                  </div>
                );
              })}
            </MenuList>
            <StyledMenu
              id="nested-menu"
              MenuListProps={{
                "aria-labelledby": "nested-menu",
              }}
              anchorEl={anchorEl}
              open={open}
              onClose={handleCloseNestedMenu}
            >
              {nestedMenu?.map((item) => {
                return (
                  <div key={item.id}>
                    <Link to={item.path} style={{ textDecoration: "none" }}>
                      <MenuItem disableRipple onClick={handleCloseNestedMenu}>
                        {item.name}
                      </MenuItem>
                    </Link>
                  </div>
                );
              })}
            </StyledMenu>
          </Grid>
        </>
      )}

      <ClickAwayListener onClickAway={() => setSettingsDrawerOpen(false)}>
        <Grid
          container
          justifyContent="space-between"
          alignItems="center"
          sx={{
            position: "absolute",
            bottom: "0px",
            left: "0px",
            borderTop: "solid",
            borderTopColor: "#E7E9EF",
            borderTopWidth: "thin",
            cursor: "pointer",
          }}
          onClick={() => setSettingsDrawerOpen(true)}
        >
          <Grid item sx={{ padding: "16px" }}>
            <Typography
              sx={{
                color: "#050D2E",
                fontSize: ".938rem",
                opacity: ".75",
                lineHeight: "17px",
                fontWeight: "600",
              }}
            >
              BANQUE MISR
            </Typography>
            <Typography
              sx={{
                color: "#50566E",
                fontSize: ".813rem",
                opacity: ".75",
                lineHeight: "14px",
                marginTop: "3px",
              }}
            >
              QNBAEGCXXXX
            </Typography>
          </Grid>
          <Grid item sx={{ padding: "22px" }}>
            <KeyboardArrowUpIcon />
          </Grid>
        </Grid>
      </ClickAwayListener>

      <Drawer
        anchor="bottom"
        sx={{
          display: { xs: "none", sm: "block" },
          "& .MuiDrawer-paper": {
            boxSizing: "border-box",
            width: "220px",
            margin: "10px",
            background: "#FFFFFF",
            height: `170px`,
            position: "absolute",
            bottom: "30px",
            borderRadius: "5px",
          },
        }}
        onClose={toggleSettingsDrawer}
        open={settingsDrawerOpen}
        hideBackdrop={true}
        transitionDuration={500}
        variant="temporary"
      ></Drawer>
    </Drawer>
  );
};

export default SideMenu;
